import type {
  ComponentSettings,
  ComponentSettingsProps,
} from "@repo/editor/externalComponents";
import { forwardRef } from "react";
import type { ComponentType } from "@repo/editor/types";
import * as t from "@rekajs/types";

export const Overflow2Definition: ComponentSettingsProps = {
  label: {
    label: "بخش با انتقال",
    section: "متن",
    type: "html",
    default: "",
  },
  image: {
    label: "تصویر",
    section: "تصویر",
    type: "image",
    default: "",
  },
  textColor: {
    label: "رنگ متن",
    section: "متن",
    type: "colorPicker",
    default: "#6A6A6A",
  },
  backgroundColor: {
    label: "رنگ پس زمینه",
    section: "پس زمینه",
    type: "colorPicker",
    default: "#DCDCDC",
  },
  alt: {
    type: "string",
    label: "عنوان تصویر",
    default: "تصویر پس زمینه",
  },
};

export interface Overflow2Props {
  label: string;
  image: string;
  textColor: string;
  backgroundColor: string;
  alt?: string;
}

export const Overflow2 = forwardRef<HTMLDivElement, Overflow2Props>(
  (props, ref) => {
    return (
      <div className="w-full h-full">
        <div
          className="flex items-center justify-center relative w-full h-full"
          ref={ref}
        >
          <div className="w-2/5" />
          <div className="w-3/5 h-full">
            <img
              alt={props.alt || String(Overflow2Definition.alt.default)}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.currentTarget.src = "/images/placeholder.png";
              }}
              src={props.image}
            />
          </div>
          <div className="md:w-4/5 w-full container mx-auto h-full absolute inset-0 top-0 left-0 flex flex-col items-start lg:justify-center justify-end pb-5 md:pb-10 lg:pb-0 content-end gap-[40px]">
            <div
              className="font-helveticaNeueLTStd text-[29.3px] md:text-[40px] lg:text-[84.94px] font-[100] lg:font-[250] leading-[1.07] lg:leading-[90.6px] ql-editor"
              dangerouslySetInnerHTML={{ __html: props.label }}
              style={{
                color:
                  props.textColor ||
                  String(Overflow2Definition.textColor.default),
              }}
            />
          </div>
        </div>
      </div>
    );
  }
) as ComponentType<Overflow2Props>;
Overflow2.displayName = "EOverflow2";

export const Overflow2Settings: ComponentSettings = {
  name: "EOverflow2",
  props: Overflow2Definition,
  label: "کامپوننت سرریز",
  widgets: {
    label: "کامپوننت سرریز",
    template: () =>
      t.componentTemplate({
        component: t.identifier({
          name: "EOverflow2",
          external: true,
        }),
        props: {
          label: t.literal({ value: "بخش سرریز" }),
        },
      }),
  },
};

Overflow2.componentSettings = Overflow2Settings;
